import {replace, range, padStart, toMilitary, sum} from 'vendor';

export const halfday = 12 * 60;
export const fullday = 24 * 60;

export const minutesInHour = range(0, 60, 5).map(value => padStart(value.toString(), 2, '0'));

export function minutes(time = '') {
  let [hours, minutes, daytime] = ''.concat(time).split(/[: ]/);
  if (hours === '12' && daytime) {
    hours = '0';
  }
  return sum([
    parseInt(hours || '0') * 60,
    parseInt(minutes || '0') * 1,
    daytime === 'PM' ? halfday : 0
  ]);
}

export function getMinutes(time: string) {
  try {
    const [hours, minutes] = toMilitary(replace(time, /^0/, '')).split(':');
    return parseInt(hours) * 60 + parseInt(minutes) * 1;
  } catch (e) {
    return null;
  }
}

export function minutesToTime(value?: number) {
  if (typeof value === 'number') {
    let daytime = ' AM';
    let hours = Math.floor(value / 60);
    if (value >= halfday) {
      hours = hours % 12;
      daytime = ' PM';
    }
    return [hours || 12, ':', padStart((value % 60).toString(), 2, '0'), daytime].join('');
  }
}

export const hoursInDay = [
  '12 AM',
  ...range(1, 12).map(e => `${e} AM`),
  '12 PM',
  ...range(1, 12).map(e => `${e} PM`)
];
